import { AppRoutes } from '../../App/routes';
import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';

export const edgesRoot = 'edges';
export const edgesBaseRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${edgesRoot}`;
export const edgeNameRouteParam = 'edgeName';
